export default __webpack_public_path__ + "static/media/porsche.ea59b47c.svg";